import React from 'react';
import PropTypes from "prop-types";

const CountryFlag = (props) => {
    const {code, width = 20, height = 15} = props;

    return (
        <img
            loading="lazy"
            width={width}
            height={height}
            src={`https://flagcdn.com/${width}x${height}/${code.toLowerCase()}.png`}
            srcSet={`https://flagcdn.com/${width * 2}x${height * 2}/${code.toLowerCase()}.png 2x`}
            alt={code.toUpperCase()}
            style={{verticalAlign: "text-top"}}
        />
    );
};

CountryFlag.propTypes = {
    code: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
};

export default CountryFlag;